(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    if (reduceMotion || typeof gsap === 'undefined') {
      document.querySelectorAll('[data-lux-reveal]').forEach(function (el) {
        el.style.opacity = 1;
      });
      initNavScroll();
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    document.documentElement.classList.add('lux-js');
    initLenis();
    initReveals();
    initSplitText();
    initMagnetic();
    initNavScroll();
    initCounters();
  }

  function initLenis() {
    if (typeof Lenis === 'undefined') return;
    var lenis = new Lenis({
      duration: 1.1,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
    });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
    window.__luxLenis = lenis;
  }

  function initReveals() {
    var namedGroups = new Map();
    var singles = [];

    document.querySelectorAll('[data-lux-reveal]').forEach(function (el) {
      var groupName = el.getAttribute('data-lux-reveal-group');
      if (!groupName) {
        singles.push([el]);
        return;
      }
      if (!namedGroups.has(groupName)) namedGroups.set(groupName, []);
      namedGroups.get(groupName).push(el);
    });

    var allGroups = Array.from(namedGroups.values()).concat(singles);

    allGroups.forEach(function (els) {
      gsap.set(els, { opacity: 0, y: 48 });
      ScrollTrigger.create({
        trigger: els[0],
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to(els, {
            opacity: 1,
            y: 0,
            duration: 1.1,
            ease: 'power3.out',
            stagger: 0.12,
          });
        },
      });
    });
  }

  function initSplitText() {
    document.querySelectorAll('[data-lux-split]').forEach(function (el) {
      var text = el.textContent.trim();
      var words = text.split(/\s+/);
      el.setAttribute('aria-label', text);
      el.textContent = '';
      words.forEach(function (word, i) {
        var line = document.createElement('span');
        line.className = 'lux-split-line';
        var inner = document.createElement('span');
        inner.className = 'lux-split-line__inner';
        inner.textContent = word + (i < words.length - 1 ? ' ' : '');
        line.appendChild(inner);
        el.appendChild(line);
      });

      var inners = el.querySelectorAll('.lux-split-line__inner');
      gsap.set(inners, { yPercent: 110 });
      ScrollTrigger.create({
        trigger: el,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          gsap.to(inners, {
            yPercent: 0,
            duration: 1,
            ease: 'power4.out',
            stagger: 0.045,
          });
        },
      });
    });
  }

  function initMagnetic() {
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    document.querySelectorAll('.lux-magnetic').forEach(function (wrap) {
      var strength = 26;
      wrap.addEventListener('mousemove', function (e) {
        var rect = wrap.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        gsap.to(wrap, {
          x: (x / rect.width) * strength,
          y: (y / rect.height) * strength,
          duration: 0.5,
          ease: 'power3.out',
        });
      });
      wrap.addEventListener('mouseleave', function () {
        gsap.to(wrap, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
      });
    });
  }

  function initNavScroll() {
    var nav = document.querySelector('.lux-nav');
    if (!nav) return;
    function update() {
      if (window.scrollY > 40) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initCounters() {
    document.querySelectorAll('[data-lux-count]').forEach(function (el) {
      var end = parseFloat(el.getAttribute('data-lux-count'));
      var suffix = el.getAttribute('data-lux-count-suffix') || '';
      var obj = { val: 0 };
      ScrollTrigger.create({
        trigger: el,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          gsap.to(obj, {
            val: end,
            duration: 1.6,
            ease: 'power2.out',
            onUpdate: function () {
              el.textContent = Math.floor(obj.val) + suffix;
            },
          });
        },
      });
    });
  }
})();
